export interface ClassicScene {
  title: string;
  desc: string;
}

export interface GoddessCharacter {
  id: string;
  name: string;
  nameEn: string;
  workId: string;
  image: string;
  epithet: string;
  race: string;
  rarity: number;
  tags: string[];
  personality: string[];
  description: string;
  classicScene: ClassicScene[];
}

export const characters: GoddessCharacter[] = [
  {
    id: "xinglan",
    name: "星澜",
    nameEn: "Xing Lan",
    workId: "xingqiong",
    image: "https://readdy.ai/api/search-image?query=ethereal%20star%20goddess%20with%20long%20silver%20hair%20woven%20with%20tiny%20golden%20constellations%2C%20flowing%20indigo%20and%20ivory%20robes%20shimmering%20with%20starlight%2C%20serene%20wise%20expression%20holding%20a%20glowing%20thread%20of%20stars%2C%20fantasy%20anime%20character%20portrait%2C%20warm%20gold%20and%20soft%20rose%20accents%2C%20luminous%20magical%20atmosphere&width=700&height=900&seq=char-xinglan-01&orientation=portrait",
    epithet: "织星者",
    race: "星神 / 星界主宰",
    rarity: 98,
    tags: ["温柔", "宿命", "织星", "星辰"],
    personality: ["温柔坚定", "悲天悯人", "冷静理性", "母性光环"],
    description:
      "星澜是星穹神系最初的织星者，掌管群星轨迹与命运交织之线。她以近乎宿命般的沉静守护星界，却在一次次牺牲中展露深情。作为贯穿《星穹之下》主线的核心女神，她被誉为「最懂温柔的力量」，人气常年高居榜首。",
    classicScene: [
      { title: "织星之夜", desc: "星澜在星穹之巅为坠落的星辰重新接线，独自承受反噬却仍对少女微笑，成为全剧催泪名场面。" },
      { title: "命运之结", desc: "明知改写宿命会折损自身神格，她仍亲手解开了主角必死的命运之结。" },
    ],
  },
  {
    id: "yelian",
    name: "夜阑",
    nameEn: "Ye Lan",
    workId: "xingqiong",
    image: "https://readdy.ai/api/search-image?query=elegant%20night%20goddess%20with%20deep%20midnight%20blue%20hair%20and%20a%20veil%20of%20scattered%20stars%2C%20dark%20indigo%20gown%20with%20silver%20embroidery%2C%20mysterious%20cool%20gaze%20with%20a%20soft%20hidden%20smile%2C%20fantasy%20anime%20character%20portrait%2C%20deep%20blue%20violet%20with%20crimson%20jewel%20accents%2C%20moonlit%20magical%20atmosphere&width=700&height=900&seq=char-yelian-02&orientation=portrait",
    epithet: "夜临女神",
    race: "夜神 / 夜幕之灵",
    rarity: 91,
    tags: ["神秘", "御姐", "月夜", "高冷"],
    personality: ["外冷内热", "嘴硬心软", "洞察力强", "护短"],
    description:
      "夜阑统御夜幕，是星穹神系中最难以捉摸的存在。她看似疏离冷淡，实则将所有人护在羽翼之下。每当危机降临，她总在暗处先一步布置好退路，因此被读者戏称为「最靠谱的幕后女神」。",
    classicScene: [
      { title: "夜幕为盾", desc: "夜阑以整片夜幕覆盖被围困的星界城，孤身断后，月色下回眸一笑，霸气与温柔并存。" },
    ],
  },
  {
    id: "yaoguang",
    name: "瑶光",
    nameEn: "Yao Guang",
    workId: "xingqiong",
    image: "https://readdy.ai/api/search-image?query=youthful%20energetic%20star%20goddess%20with%20bright%20golden-brown%20hair%20and%20twinkling%20constellation%20freckles%2C%20short%20ivory%20and%20gold%20battle%20robe%2C%20lively%20confident%20smile%20holding%20a%20small%20blazing%20star%20orb%2C%20fantasy%20anime%20character%20portrait%2C%20warm%20gold%20amber%20and%20coral%20tones%2C%20bright%20playful%20magical%20atmosphere&width=700&height=900&seq=char-yaoguang-03&orientation=portrait",
    epithet: "北辰女神",
    race: "星神 / 北斗守将",
    rarity: 87,
    tags: ["元气", "战斗", "北辰", "守护"],
    personality: ["热血直率", "行动派", "乐观", "讲义气"],
    description:
      "瑶光是镇守北辰的年轻星神，性格热烈张扬，作战风格雷厉风行。她是最先接纳误入星界少女的角色，以爽朗与赤诚收获了极高的人气，是无数读者心中的「最佳伙伴型女神」。",
    classicScene: [
      { title: "北辰不退", desc: "面对倾巢而来的暗星大军，瑶光一人立于北辰之巅，喊出「星辰所向，我即屏障」后迎战强敌。" },
    ],
  },
  {
    id: "yuejian",
    name: "月见",
    nameEn: "Yue Jian",
    workId: "yuehua",
    image: "https://readdy.ai/api/search-image?query=graceful%20moon%20goddess%20in%20flowing%20pale%20jade%20and%20white%20kimono%20with%20translucent%20veil%2C%20hair%20like%20pale%20moonlight%20with%20a%20small%20crescent%20ornament%2C%20gentle%20serene%20smile%20under%20a%20full%20moon%2C%20wafu%20fantasy%20anime%20character%20portrait%2C%20soft%20ivory%20silver%20and%20muted%20vermilion%2C%20tranquil%20elegant%20moonlit%20atmosphere&width=700&height=900&seq=char-yuejian-04&orientation=portrait",
    epithet: "月之神",
    race: "月神 / 月华之主",
    rarity: 95,
    tags: ["温婉", "月神", "祭典", "古典"],
    personality: ["温婉娴静", "柔中带刚", "善解人意", "隐忍"],
    description:
      "月见是守护人间月华的月之神，性情温婉如水，却在关键时刻展现出不容置疑的坚定。每年月华祭典由她亲自主持，一袭月白和服于月光下起舞的场景，成为《月华祭典》最具代表性的画面。",
    classicScene: [
      { title: "月下之舞", desc: "月华祭典之夜，月见于千盏河灯间独舞，以自身月光驱散侵袭人间的瘴气，美得令人屏息。" },
      { title: "无声之誓", desc: "她隐瞒伤痛守护人间百年，直到被揭穿那一刻才轻声道出「守护本就无需被知晓」。" },
    ],
  },
  {
    id: "jiangyun",
    name: "绛云",
    nameEn: "Jiang Yun",
    workId: "yuehua",
    image: "https://readdy.ai/api/search-image?query=fiery%20yet%20elegant%20sunset%20cloud%20goddess%20with%20long%20crimson%20hair%20like%20burning%20clouds%2C%20vermilion%20and%20gold%20layered%20kimono%20with%20cloud%20patterns%2C%20determined%20passionate%20gaze%2C%20wafu%20fantasy%20anime%20character%20portrait%2C%20warm%20vermilion%20coral%20and%20amber%20tones%2C%20dynamic%20radiant%20sunset%20atmosphere&width=700&height=900&seq=char-jiangyun-05&orientation=portrait",
    epithet: "霞光女神",
    race: "霞神 / 晚霞之灵",
    rarity: 89,
    tags: ["热烈", "霞光", "赤诚", "洒脱"],
    personality: ["热烈外放", "嫉恶如仇", "重情重义", "洒脱不羁"],
    description:
      "绛云是晚霞化身的霞光女神，性情如火，快意恩仇。她与月见一热一冷，却并肩守护人间千年。每当人间遭遇不公，总有一抹绛红霞光划破天际，成为她登场的标志。",
    classicScene: [
      { title: "霞光破晓", desc: "为救被囚的友人，绛云以一身霞光撞碎妖界结界，宣告「我的人，谁都不能动」。" },
    ],
  },
  {
    id: "fuleiya",
    name: "芙蕾雅·曦光",
    nameEn: "Freya Soluna",
    workId: "jileshengyu",
    image: "https://readdy.ai/api/search-image?query=majestic%20dawn%20goddess%20with%20flowing%20golden%20hair%20and%20a%20radiant%20sun%20halo%2C%20ivory%20and%20gold%20ceremonial%20armor%20dress%20with%20crimson%20sash%2C%20serene%20authoritative%20smile%20radiating%20warmth%2C%20high%20fantasy%20anime%20character%20portrait%2C%20ivory%20gold%20and%20crimson%20palette%2C%20divine%20glorious%20dawn%20atmosphere&width=700&height=900&seq=char-fuleiya-06&orientation=portrait",
    epithet: "晨曦女神",
    race: "光之女神 / 圣域神座",
    rarity: 97,
    tags: ["神圣", "晨曦", "端庄", "领袖"],
    personality: ["端庄大器", "心怀苍生", "果决", "慈悲"],
    description:
      "芙蕾雅·曦光是极乐圣域十二神座之首，执掌晨曦与新生之力。她以「光必先于暗照见归途」为信念，是圣域的精神支柱。其端庄与慈悲并存的形象，被公认为最具「神性」的女神角色。",
    classicScene: [
      { title: "黎明降临", desc: "圣域倾覆之际，芙蕾雅于晨曦中展开十二翼，以新生之光为全军将士重铸信念。" },
    ],
  },
  {
    id: "leina",
    name: "雷娜",
    nameEn: "Raina",
    workId: "jileshengyu",
    image: "https://readdy.ai/api/search-image?query=fierce%20thunder%20goddess%20with%20wild%20silver-white%20hair%20crackling%20with%20lightning%20and%20sharp%20gold%20eyes%2C%20dark%20armor%20with%20crimson%20accents%20wielding%20a%20crackling%20spear%2C%20confident%20battle-ready%20stance%2C%20high%20fantasy%20anime%20character%20portrait%2C%20deep%20charcoal%20crimson%20and%20electric%20gold%20tones%2C%20powerful%20storm%20atmosphere&width=700&height=900&seq=char-leina-07&orientation=portrait",
    epithet: "雷霆女神",
    race: "雷之女神 / 圣域战将",
    rarity: 90,
    tags: ["强气", "雷霆", "战将", "傲娇"],
    personality: ["强气傲娇", "嘴硬心软", "战力超群", "反差萌"],
    description:
      "雷娜是执掌雷霆的圣域战将，性子火爆、嘴上从不服软，却总在私下默默守护同伴。她与芙蕾雅的互动是全剧人气最高的搭档线，刚烈外表下藏着细腻的反差萌。",
    classicScene: [
      { title: "雷霆一怒", desc: "面对来犯的邪神，雷娜化作雷暴本体纵横战场，怒斥「犯我圣域者，当受万雷之罚」。" },
    ],
  },
  {
    id: "fuluola",
    name: "芙萝拉",
    nameEn: "Flora",
    workId: "jileshengyu",
    image: "https://readdy.ai/api/search-image?query=gentle%20flower%20goddess%20with%20soft%20rose-pink%20hair%20crowned%20with%20fresh%20flowers%2C%20flowing%20pastel%20petal%20gown%2C%20kind%20nurturing%20smile%20surrounded%20by%20floating%20blossoms%2C%20high%20fantasy%20anime%20character%20portrait%2C%20soft%20rose%20blush%20and%20warm%20ivory%20tones%2C%20tender%20dreamy%20garden%20atmosphere&width=700&height=900&seq=char-fuluola-08&orientation=portrait",
    epithet: "花之女神",
    race: "花之女神 / 圣域丰饶",
    rarity: 88,
    tags: ["治愈", "花神", "温柔", "丰饶"],
    personality: ["治愈温柔", "乐观", "乐于助人", "坚韧"],
    description:
      "芙萝拉是执掌花与丰饶之力的花之女神，所到之处百花盛放。她性格温柔治愈，是圣域中最受眷顾的存在，却也有着在枯萎花田里独自哭泣的柔软一面，令人心疼又喜爱。",
    classicScene: [
      { title: "繁花回响", desc: "芙萝拉以自身神力让战后的荒原一夜繁花盛开，为人们带来重生的希望。" },
    ],
  },
  {
    id: "xueyin",
    name: "雪音",
    nameEn: "Xue Yin",
    workId: "huanghun",
    image: "https://readdy.ai/api/search-image?query=quiet%20ice%20goddess%20with%20pale%20snow-white%20hair%20and%20icy%20blue-violet%20eyes%2C%20elegant%20white%20and%20silver%20modern-fantasy%20coat%20with%20frost%20patterns%2C%20composed%20aloof%20expression%2C%20urban%20fantasy%20anime%20character%20portrait%2C%20cool%20white%20silver%20and%20muted%20blue%20tones%2C%20crisp%20serene%20snowy%20atmosphere&width=700&height=900&seq=char-xueyin-09&orientation=portrait",
    epithet: "冰雪女神",
    race: "冰雪之神 / 都市守护者",
    rarity: 93,
    tags: ["高冷", "冰雪", "都市", "守护"],
    personality: ["冷静克制", "外冷内暖", "责任感强", "隐忍"],
    description:
      "雪音是隐匿于现代都市的冰雪之神，白天是淡漠的白领，入夜则以契约守护整座城市。她用严寒的疏离包裹最深的温柔，那句「冷，是为了让在意之人不被灼伤」让无数读者破防。",
    classicScene: [
      { title: "初雪之约", desc: "大雪封城的夜晚，雪音以一己之力冻结失控的契约之力，在初雪中护住了整座城市。" },
    ],
  },
  {
    id: "youmeng",
    name: "幽梦",
    nameEn: "You Meng",
    workId: "huanghun",
    image: "https://readdy.ai/api/search-image?query=mysterious%20dream%20goddess%20with%20soft%20lavender-violet%20hair%20dissolving%20into%20mist%20and%20swirling%20dream%20motes%2C%20flowing%20sheer%20indigo%20gown%2C%20gentle%20elusive%20smile%2C%20urban%20fantasy%20anime%20character%20portrait%2C%20soft%20lavender%20violet%20and%20warm%20rose%20accents%2C%20dreamy%20ethereal%20atmosphere&width=700&height=900&seq=char-youmeng-10&orientation=portrait",
    epithet: "梦境女神",
    race: "梦境之神 / 意识领域",
    rarity: 85,
    tags: ["梦幻", "梦境", "神秘", "治愈"],
    personality: ["天真缥缈", "洞察人心", "温柔治愈", "孤独"],
    description:
      "幽梦游走于所有人的梦境之间，既能看到最深的恐惧，也能织出最甜的美梦。她天真缥缈又异常通透，是《黄昏契约》中最具治愈气质却最孤独的角色。",
    classicScene: [
      { title: "梦醒时分", desc: "幽梦为困于噩梦的少年织出一场告别之梦，梦醒后悄然消失，只留下一句「愿你的现实也是美梦」。" },
    ],
  },
  {
    id: "canglan",
    name: "苍澜",
    nameEn: "Cang Lan",
    workId: "canglan",
    image: "https://readdy.ai/api/search-image?query=serene%20sea%20goddess%20with%20flowing%20teal-turquoise%20hair%20and%20pearl%20ornaments%2C%20elegant%20aqua%20and%20gold%20flowing%20robe%20trailing%20like%20water%2C%20calm%20wise%20smile%20with%20gentle%20eyes%2C%20ocean%20myth%20fantasy%20anime%20character%20portrait%2C%20teal%20turquoise%20and%20soft%20gold%20accents%2C%20tranquil%20underwater%20atmosphere&width=700&height=900&seq=char-canglan-11&orientation=portrait",
    epithet: "海洋女神",
    race: "海之神 / 苍蓝之主",
    rarity: 92,
    tags: ["沉静", "海洋", "智慧", "包容"],
    personality: ["沉静智慧", "包容万物", "外柔内韧", "深谋远虑"],
    description:
      "苍澜是掌管整片海域的海洋女神，沉静而包容，如海水般容纳一切喜怒哀乐。她行事深谋远虑，以近乎绝对的耐心守护海域千年，是苍蓝神殿的精神根基。",
    classicScene: [
      { title: "海之心潮", desc: "为平息海怪之乱，苍澜以自身神格镇守海底裂隙，默默承受百年的孤独守望。" },
    ],
  },
  {
    id: "xiyue",
    name: "汐月",
    nameEn: "Xi Yue",
    workId: "canglan",
    image: "https://readdy.ai/api/search-image?query=playful%20tide%20goddess%20with%20silver-aqua%20hair%20and%20shell%20hairpins%2C%20luminous%20pearl-white%20and%20teal%20flowing%20dress%2C%20lively%20curious%20smile%20riding%20a%20wave%20of%20glowing%20water%2C%20ocean%20myth%20fantasy%20anime%20character%20portrait%2C%20pearl%20white%20teal%20and%20soft%20gold%20tones%2C%20bright%20cheerful%20underwater%20atmosphere&width=700&height=900&seq=char-xiyue-12&orientation=portrait",
    epithet: "潮汐女神",
    race: "潮汐之神 / 海流之灵",
    rarity: 86,
    tags: ["灵动", "潮汐", "活泼", "自由"],
    personality: ["活泼灵动", "自由不羁", "好奇心强", "率真"],
    description:
      "汐月是掌控潮汐的海流之灵，性格如潮汐般忽而汹涌忽而温柔。她最向往陆地的四季，总爱偷偷溜上海面张望，率真俏皮的模样为深沉的苍蓝神殿注入鲜活气息。",
    classicScene: [
      { title: "潮涌如歌", desc: "汐月以整个潮汐之力托起沉船，救下满船旅人，随后俏皮地藏在珊瑚后偷笑。" },
    ],
  },
];

export const getCharacter = (id: string): GoddessCharacter | undefined =>
  characters.find((c) => c.id === id);